import React, {useContext, useRef} from "react";
import {
    Checkbox,
    Col, Dropdown,
    Icon, Menu,
    Popconfirm,
    Row,
    Typography,
} from "antd";
import "./FlightScheduleLegPax.less";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ETable from "components/enchanced-antd-table";
import { MultiSelectReturn } from "hooks/useMultiSelect";
import { ColumnProps } from "antd/lib/table";
import {createScheduledEntityColumns} from "./columns";
import {createLegListSelectColumn, renderGroupNameMenuItems} from "./FlightScheduleUtils";
import {FlightLeg} from "../../../schema";
import useUserGroups from "../../../hooks/useUserGroups";
import {OrgDataContext} from "../../../context/orgData";
import {isTalosCustomer} from "../../../common/constants/organizations";
import {FlightEditorEntityColumn} from "../../flighteditor/unified/configuration";
import RemoveRedundantLegButton from './RemoveRedundantLegButton';

library.add(faBoxOpen);

type TEMP_TYPE_Flight = any;
type TEMP_TYPE_Pax = any;
type TEMP_TYPE_Cgo = any;
type TEMP_TYPE_Entity = TEMP_TYPE_Pax | TEMP_TYPE_Cgo

export interface FlightScheduleLegPaxProps {
    flight: TEMP_TYPE_Flight,
    selectedLegIndex: number,
    departureName: string;
    destinationName: string;
    multiSelect?: MultiSelectReturn<TEMP_TYPE_Entity>,
    events: {
        onRemoveRedundantLeg?: () => void
    },
    readOnly?: boolean,
    disabled?: boolean,
    showNotesForPilot?: boolean,
    columns?: FlightEditorEntityColumn[]
}

const FlightScheduleLegPax: React.FC<FlightScheduleLegPaxProps> = (props) => {
    const {
        selectedLegIndex,
        flight,
        departureName,
        destinationName,
        multiSelect ,
        events,
        readOnly,
        disabled
    } = props;

    const legs: FlightLeg[] = (flight.legs && Object.values(JSON.parse(flight.legs))) || []
    const selectedLeg = legs?.[selectedLegIndex];
    const containerRef = useRef<HTMLDivElement>(null);
    const orgData = useContext(OrgDataContext);
    const allEntities = [...flight.paxIDList, ...flight.cgoIDList];

    const paxObjList: TEMP_TYPE_Pax[] = flight?.paxIDList?.filter(p => selectedLeg?.paxIDs?.includes(p._id));
    const cgoObjList: TEMP_TYPE_Cgo[] = flight?.cgoIDList?.filter(c => selectedLeg?.cgoIDs?.includes(c._id));

    if (!(paxObjList || cgoObjList)){
        return <h2 style={{marginTop: '10rem', textAlign: 'center', color: 'grey'}}>No leg data available</h2>
    }

    let paxSortedList = [...paxObjList];
    let cgoSortedList = [...cgoObjList];

    paxSortedList.sort((a, b) => String(a.lastName + ', ' + a.firstName).localeCompare(String(b.lastName + ', ' + b.firstName)))
    cgoSortedList.sort((a, b) => String(a.name).localeCompare(String(b)))

    let combinedList = []
    if(paxSortedList?.length > 0){
        combinedList = combinedList.concat(paxSortedList)
    }
    if(cgoSortedList?.length > 0){
        combinedList = combinedList.concat(cgoSortedList)
    }

    const columns = createScheduledEntityColumns(selectedLeg, {
        containerRef: containerRef.current,
        showSafetyCard: isTalosCustomer(orgData?.customerID),
        showNotesForPilot: props.showNotesForPilot,
        columns: props.columns
    });

    if (multiSelect && !readOnly){
        columns.unshift(createLegListSelectColumn(multiSelect, combinedList));
    }

    return (
        <React.Fragment>
            <div ref={containerRef}>
                <Row type="flex" style={{marginBottom: '1rem', alignItems: 'center'}} gutter={12}>
                    <Col style={{flex: 1}}>
                        <h3 style={{margin: 0}}>
                            {departureName && destinationName ?
                                `${departureName} to ${destinationName}` :
                                ''
                            }
                        </h3>
                    </Col>
                    <RemoveRedundantLegButton
                        disabled={disabled}
                        readOnly={readOnly}
                        onRemove={props.events?.onRemoveRedundantLeg}
                    />
                </Row>
                <ETable.Group>
                    <ETable
                        className='mc-table mc-scheduling-leg-pax'
                        dataSource={combinedList}
                        columns={columns}
                        onRowClick={(record: TEMP_TYPE_Entity) => {
                            if (readOnly) return;
                            multiSelect?.toggleSelection(record);
                        }}
                        onRow={() => (
                            {
                                style: {
                                    cursor: !readOnly ? 'pointer' : 'default'
                                }
                            }
                        )}
                        rowClassName={() => "mc-cursor-pointer"}
                        rowKey={(record: TEMP_TYPE_Entity) => record._id}
                        size="small"
                        // scroll={{
                        //     x: 'max-content'
                        // }}
                        pagination={false}
                    />
                </ETable.Group>
            </div>
        </React.Fragment>
    )
}

export default FlightScheduleLegPax
